import React, { FC } from 'react';
import { Skeleton, PageHeading } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useLoadWebhooks } from 'src/models/company/Webhooks/hooks';
import WebhooksList from './WebhooksList';
import { WebhookCreate } from './WebhooksActions';
import { faShareAlt } from '@fortawesome/pro-light-svg-icons';

interface IProps {}
export const Webhooks: FC<IProps> = () => {
  const { t } = useTranslation();
  const { loading: webhooksLoading } = useLoadWebhooks();

  return (
    <>
      <PageHeading
        title={t('Navigation.Settings.webhooks')}
        icon={faShareAlt}
        desc={
          <>
            <p>{t('Webhooks.webhooksDesc1')}</p>
            <p>{t('Webhooks.webhooksDesc2')}</p>
          </>
        }
      />
      {webhooksLoading ? (
        <Skeleton loading active />
      ) : (
        <>
          <WebhookCreate />
          <WebhooksList />
        </>
      )}
    </>
  );
};

export default Webhooks;
